class HeroProductMix extends HTMLElement {
  connectedCallback() {
    this.mixProducts();
  }

  mixProducts() {
    const limit = Number.parseInt(this.dataset.limit || '4', 10);
    const cards = this.shuffle([...this.querySelectorAll('.hero-products__card')]);

    if (cards.length <= limit) {
      cards.forEach((card) => this.showCard(card));
      return;
    }

    const groups = new Map();
    for (const card of cards) {
      const group = card.dataset.mixGroup || 'weitere';
      const bucket = groups.get(group) || [];
      bucket.push(card);
      groups.set(group, bucket);
    }

    const buckets = this.shuffle([...groups.values()].map((bucket) => this.shuffle(bucket)));
    const selected = [];

    while (selected.length < limit && buckets.some((bucket) => bucket.length > 0)) {
      for (const bucket of buckets) {
        const card = bucket.shift();
        if (card) selected.push(card);
        if (selected.length === limit) break;
      }
    }

    cards.forEach((card) => {
      card.hidden = true;
      card.classList.remove('is-visible');
    });

    const grid = this.querySelector('.hero-products__grid');
    for (const card of this.shuffle(selected)) {
      this.showCard(card);
      grid?.append(card);
    }
  }

  showCard(card) {
    card.hidden = false;
    card.classList.add('is-visible');
  }

  shuffle(items) {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
    }
    return items;
  }
}

if (!customElements.get('hero-product-mix')) {
  customElements.define('hero-product-mix', HeroProductMix);
}
